import { GET, POST, PUT, DELETE } from './core';

export const getAllLoyaltyTiers = (token) =>
  GET('/loyalty-tier', token);

export const addTier = (token, payload) =>
  POST('/loyalty-tier/create', payload, token);

export const updateTier = (token, payload) =>
  PUT('/loyalty-tier/update', payload, token);

export const deleteTier = (token, id) =>
  DELETE(`/loyalty-tier/delete/${id}`, {}, token);
